export const INLINE = 'INLINE';
export const HEADER = 'HEADER';

export const INLINE_READ_TESTID =
	'issue-field-summary.ui.multiline-inline-summary.ui.read.link-item';
